export default "__VITE_ASSET___gbKOGMT__"